import { useEffect, useState } from "react";
import { useToastContext } from "../contexts/ToastContext/ToastContext";
import GetUserInfoService from "../service/GetUserInfoService";
import useApiStatus from "./useApiStatus";
import { useFavoritesDispatch } from "../contexts/FavoritesContext/FavoritesContext";
import { removeFavorite } from "../contexts/FavoritesContext/actions";

const useUnfavorite = () => {
  const [products, setProducts] = useState([]);
  const { isLoading, setIsLoading } = useApiStatus();
  const { isLoading: isLoadingUnfavoriting, setIsLoading: setIsLoadingUnfavoriting } =
    useApiStatus();
  const dispatch = useFavoritesDispatch();
  const { showErrorToast } = useToastContext();

  const getUserInfoService = new GetUserInfoService();

  const unfavoriteProduct = async (productId) => {
    setIsLoadingUnfavoriting(true);
    try {
      const resCategories = await getUserInfoService.deleteFavorite(
        localStorage.getItem("__extraconomy_token"),
        productId,
        localStorage.getItem("__extraconomy_username")
      );

      if (resCategories.messageCode !== 200003) {
        showErrorToast({ code: resCategories.messageCode });
        setIsLoadingUnfavoriting(false);
        return;
      }

      dispatch(removeFavorite());
      setProducts((prevProducts) =>
        prevProducts.filter((product) => product.product.id !== productId)
      );
      setIsLoadingUnfavoriting(false);
    } catch (e) {
      setIsLoadingUnfavoriting(false);
      console.log(e);
    }
  };

  const getFavorites = async () => {
    try {
      setIsLoading(true);
      const res = await getUserInfoService.getFavorites(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username")
      );

      if (res.messageCode !== 200001) {
        showErrorToast({ code: res.messageCode });
        if (res.messageCode === 500000) console.log(res);
        setIsLoading(false);
      } else {
        setProducts(res.result);
        setIsLoading(false);
      }
    } catch (e) {
      if (e.status === 401 || e.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      }
      setIsLoading(false);
      console.log(e);
    }
  };

  useEffect(() => {
    getFavorites();
    return () => setProducts([]); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    products,
    setProducts,
    isLoading,
    setIsLoading,
    unfavoriteProduct,
    isLoadingUnfavoriting,
  };
};

export default useUnfavorite;
